import React from 'react'
import AuthLayout from '@SiteContainers/AuthLayout'

import './UsersPasswordEdit.scss'

const UsersPasswordEdit: React.FC = () => {
  return (
    <div className="UsersPasswordEdit">
      <AuthLayout initialScreen="password"/>
    </div>
  )
}

export default UsersPasswordEdit
